var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Zone Observations")]),_c('v-card-text',[_c('v-data-table',{attrs:{"data-cy":"observations","items":_vm.zone.observations,"headers":_vm.headers},scopedSlots:_vm._u([{key:`item.when`,fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.formatDateTime(item.when))+" ")]}}],null,true)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }